module.exports = __webpack_public_path__ + "media/images/icons/flags/OM-fb10fd8ca650665f11f5da4e9bd79186.svg";